//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Pod.WebClient.GPodUtils.ts                           </Name>
//    <Description>                                                             </Description>
//    <Author>      Šebesta David                                               </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018                            </Copyright>
//    <Created>     2018-07-27                                                  </Created>
//  </FileHeader>

namespace Gordic.Pod.GPodFunction {

    //export function GetSrv(): GContent {
    //    return new GContent({ className: "Gordic.Pod.WebControls.GPodUtils", params: {} }); 
    //}

    export function GetTypZarazeniElSouboruByPriznak(priznak: string): Interface.TypZarazeniElSouboru
    {
        switch (priznak) {
            case "elPodpis":
                return Interface.TypZarazeniElSouboru.elPodpis;
            case "casRazitko":
                return Interface.TypZarazeniElSouboru.casoveRazitko;
            case "original":
                return Interface.TypZarazeniElSouboru.original;
            case "priloha":
                return Interface.TypZarazeniElSouboru.priloha;
            case "vnorenaPriloha":
                return Interface.TypZarazeniElSouboru.vnorenaPriloha;
            default:
                return Interface.TypZarazeniElSouboru.priloha;
        }
    } 

    export function GetGIconDefinitionTypZarazeniElSouboru(typ: Interface.TypZarazeniElSouboru): IconTemplate{
        let ico: IconTemplate = {};
        switch (typ) {
            case Interface.TypZarazeniElSouboru.original:
                //l_oIkona.ikona = "Wfl/e_dokument";
                //l_oIkona.tooltip = GResources.GetResourceText(Assembly.GetExecutingAssembly(), 23820112); //RC 23820112 : originál
                ico.icon = "gi-radio2 g-state-text g-state-warning ";
                ico.tooltip = "originál";
                break;
            case Interface.TypZarazeniElSouboru.priloha:
                //l_oIkona.ikona = "Gin/priloha";
                //l_oIkona.tooltip = GResources.GetResourceText(Assembly.GetExecutingAssembly(), 23820113); //RC 23820113 : příloha
                ico.icon = "gi-eattachment";
                ico.tooltip = "příloha";
                break;
            case Interface.TypZarazeniElSouboru.elPodpis:
                //l_oIkona.ikona = "Gin/e_podpis";
                //l_oIkona.tooltip = GResources.GetResourceText(Assembly.GetExecutingAssembly(), 23820114); //RC 23820114 : el.podpis
                ico.icon = "gi-signel";
                ico.tooltip = "el.podpis";
                break;
            case Interface.TypZarazeniElSouboru.casoveRazitko:
                //l_oIkona.ikona = "Gin/casove_razitko";
                //l_oIkona.tooltip = GResources.GetResourceText(Assembly.GetExecutingAssembly(), 23820115); //RC 23820115 : čas.razítko
                ico.icon = "gi-stamp";
                ico.tooltip = "čas.razítko";
                break;
            default:
                ico.icon = "";
                ico.tooltip = "";
                break;
        }
        return ico;
    } 

    export function GetGIconDefinitionTypPodpisu(typ: Wfl.Interface.TypPodepsaniEnum): IconTemplate {
        let ico: IconTemplate = {};
        switch (typ)
        {
            case Wfl.Interface.TypPodepsaniEnum.podpis:
                ico.icon = Gordic.Gin.Icons.EntityEnum.elPodpis;
                ico.tooltip = "jres:23900163"; //RC 23900163 : Elektronický podpis
                break;
            case Wfl.Interface.TypPodepsaniEnum.casoveRazitko:
                ico.icon = Gordic.Gin.Icons.EntityEnum.casoveRazitko;
                ico.tooltip = "jres:23900164"; //RC 23900164 : Časové razítko
                break;
            case Wfl.Interface.TypPodepsaniEnum.podpisACasoveRazitko:
                ico.icon = Gordic.Gin.Icons.EntityEnum.elPodpisSCasRazitkem;
                ico.tooltip = "jres:23900165"; //RC 23900165 : Elektronický podpis a časové razítko
                break;
            default:
                ico.icon = "";
                ico.tooltip = "";
                break;
        }
        return ico;
    } 

    export function GetGIconDefinitionStavOvereni(typ: Wfl.Interface.TypVysledkuVerifikaceElPodpisu): IconTemplate {
        let ico: IconTemplate = {};
        switch (typ) {
            case Wfl.Interface.TypVysledkuVerifikaceElPodpisu.neplatnyPodpis:
            case Wfl.Interface.TypVysledkuVerifikaceElPodpisu.nepodporovano:
            case Wfl.Interface.TypVysledkuVerifikaceElPodpisu.spatnyKlic:
                ico.icon = Gordic.Gin.Icons.StavEnum.neprovedeno;
                ico.tooltip = "jres:23900167"; //RC 23900167 : Neplatný podpis
                break;
            case Wfl.Interface.TypVysledkuVerifikaceElPodpisu.overeno:
                ico.icon = Gordic.Gin.Icons.StavEnum.provedeno;
                ico.tooltip = "jres:23900166" //RC 23900166 : Ověřeno
                break;
            default:
                ico.icon = "";
                ico.tooltip = "";
                break;
        }
        return ico;
    } 
    export function GetGIconDefinitionVysledekOvereni(typ: Wfl.Interface.VysledekOvereniEnum): IconTemplate {
        let ico: IconTemplate = {};
        switch (typ) {
            case Wfl.Interface.VysledekOvereniEnum.overeni_se_nepodarilo:
            case Wfl.Interface.VysledekOvereniEnum.overeno_s_upozornenim:
            case Wfl.Interface.VysledekOvereniEnum.overeno_nevalidni:
                ico.icon = Gordic.Gin.Icons.StavEnum.neprovedeno;
                ico.tooltip = "jres:23900167"; //RC 23900167 : Neplatný podpis
                break;
            case Wfl.Interface.VysledekOvereniEnum.overeno_OK:
                ico.icon = Gordic.Gin.Icons.StavEnum.provedeno;
                ico.tooltip = "jres:23900166" //RC 23900166 : Ověřeno
                break;
            default:
                ico.icon = "";
                ico.tooltip = "";
                break;
        }
        return ico;
    } 
    /*
    export function GetGIconDefinitionStavElPodpisu(typ: Wfl.Interface.VysledekOvereniEnum): IconTemplate { 
        let ico: IconTemplate = {};
        switch (typ) {
            case Wfl.Interface.VysledekOvereniEnum.neurceno:
                ico.icon = "Gin/nic";
                ico.tooltip = "";
                break;
            case Wfl.Interface.VysledekOvereniEnum.overeno_OK:
                ico.icon = "Gin/e_podpis_overeno";
                ico.tooltip = "";
                break;
            case Wfl.Interface.VysledekOvereniEnum.overeno_nevalidni:
                ico.icon = "Gin/e_podpis_neplatny";
                ico.tooltip = "";
                break;
            case Wfl.Interface.VysledekOvereniEnum.overeno_s_upozornenim:
                ico.icon = "Gin/e_podpis_overit";
                ico.tooltip = "";
                break;
            case Wfl.Interface.VysledekOvereniEnum.overeni_se_nepodarilo:
                ico.icon = "Gin/e_podpis_overit";
                ico.tooltip = "";
                break;
            default:
                break;
        }
        return ico;
    }

    export function GetGIconDefinitionStavCasRazitka(typ: Wfl.Interface.VysledekOvereniEnum): IconTemplate {
        let ico: IconTemplate = {};
        switch (typ) {
            case Wfl.Interface.VysledekOvereniEnum.overeno_OK:
                ico.icon = "Gin/casove_razitko_overeno";
                ico.tooltip = "";
                break;
            case Wfl.Interface.VysledekOvereniEnum.overeno_nevalidni:
                ico.icon = "Gin/casove_razitko_neplatne";
                ico.tooltip = "";
                break;
            case Wfl.Interface.VysledekOvereniEnum.overeno_s_upozornenim:
                ico.icon = "Gin/casove_razitko_overit";
                ico.tooltip = "";
                break;
            case Wfl.Interface.VysledekOvereniEnum.overeni_se_nepodarilo:
                ico.icon = "Gin/casove_razitko_overit";
                ico.tooltip = "";
                break;
        }
        return ico;
    }
    */

 

    export function GetGIconDefinitionPrizAntivir(typ: Gordic.Wfl.Interface.WflcavkEnum): IconTemplate {
        let ico: IconTemplate = {};
        switch (typ) {
            case Gordic.Wfl.Interface.WflcavkEnum.OK:

                ico.icon = "gi-tick g-state-text " + Gin.Globals.Enums.ColorStateClass.success;
                ico.tooltip = "zkontrolováno";
                break;
            case Gordic.Wfl.Interface.WflcavkEnum.infikovano:
                ico.icon = "gi-exclam g-state-text " + Gin.Globals.Enums.ColorStateClass.important;
                ico.tooltip = "nalezen virus";
                break;
            default:
                ico.icon = "gi-question";
                ico.tooltip = "nezkontrolováno";
                break;
        }
        return ico;
    } 

    export function GetGIconZpracovatJakoSamostatnouPrilohu(): IconTemplate {
        let ico: IconTemplate = {};
        ico.icon = "gi-eattachment g-state-text " + Gin.Globals.Enums.ColorStateClass.warning;
        ico.tooltip = "Zpracovat jako samostatnou přílohu";
        return ico;
    } 
    /* // přesunuto do GPodUtils.ts
    export function NovyCiziDokumentPodatelna(content: GContent | null) {
        var options = {
            TypDok: Gordic.Wfl.Globals.Enums.TypDok.Cizi,
            TypId: Gordic.Wfl.Globals.Enums.TypId.IXP //  asi přepnout na ixs
        };
        Gordic.Wfl.Dialogs.GenerovaniIxp(null, options, Gordic.Global.Enums.ModOtevreni.showModalWindow).done(function (retVal) {
            if (retVal) {
                ShowDetailPoVygenerovaniIxp(retVal, 2, content); // 2==cizí
            }
        });
    }
    export function ShowDetailPoVygenerovaniIxp(rv: { Ixp: string, IxpExist: boolean }, rezimPodani: number, content:GContent|null) {
        if (rv != null) {
            var modOtevreni = Gordic.Global.Enums.ModOtevreni.navigateTask;

            if (content != null) {
                modOtevreni = Gordic.Global.Enums.ModOtevreni.navigate;
            }

            if (rv.IxpExist === false) {
                // GetGlobalManager().SendClassMessage(this, 'Default', 'OpenDetailNovy', \"?ixp=\" + rv.Ixp + \"&CiziVlastni=Cizi\");
                //GDlg.alert("Zde má následovat otevreni detailu v režimu podání s ixp: " + rv.Ixp);

                const params = {
                    Ixp: rv.Ixp,
                    ModFormu: Interface.ModFormuPodaniEnum.NovePodani,
                    //IDZpravy: opt.IDZpravy ? opt.IDZpravy : undefined,
                    //TypPid: opt.TypPid ? opt.TypPid : Wfl.Interface.TypPid.neurceno,
                    //DataPosty: opt.DataPosty ? opt.DataPosty : undefined
                };


                Gordic.Pod.Dialogs.PodaniOpravaPisemnostiDlg(content, params, modOtevreni).done(function (ret:any) {
                    if (ret != null && ret.automatickyUzavreno) { // pokud uzavřeno uložením nabídnu dálší
                        NovyCiziDokumentPodatelna(content);
                    }

                });
            } else { // pokud ixp jiz existuje zobrazim detail
                const params2 = {
                    Ixp: rv.Ixp,
                    ModFormu: Interface.ModFormuPodaniEnum.OpravaPodani,
                    //IDZpravy: opt.IDZpravy ? opt.IDZpravy : undefined,
                    //TypPid: opt.TypPid ? opt.TypPid : Wfl.Interface.TypPid.neurceno,
                    //DataPosty: opt.DataPosty ? opt.DataPosty : undefined
                };
                Gordic.Pod.Dialogs.PodaniOpravaPisemnostiDlg(content, params2, modOtevreni);
            }
        }

    }
    */
    
        
}
